<template>
  <v-app>
    <v-app-bar
      app
      color="#241e20"
      dark
    >
      <v-toolbar-title>
        <img
          alt="Nuria Daviu Estilisme Logo"
          :src="require('./assets/logonew3.png')"
          transition="scale-transition"
          :style="heightLogo"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <div v-for="(item, i) in menu" :key="i" >
          <v-btn v-if="!item.sublinks" :to="item.to" plain class="naranja"> {{ item.title }}</v-btn>
          <v-menu v-else open-on-hover bottom offset-y >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" :to="item.to" plain class="naranja"> {{ item.title }}</v-btn>
            </template>
            <v-list dark >
                <v-list-item :to="subitem.to" v-for="(subitem, i) in item.sublinks" :key="i">
                    <v-list-item-title class="naranja" plain>{{ subitem.title }}</v-list-item-title>
                  </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-else>
        <v-menu bottom left >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="naranja">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list dark @click.stop>
              <div  v-for="(item, i) in menu" :key="i" >
                <v-list-item v-if="!item.sublinks" :to="item.to"
                  >
                  <v-list-item-title class="naranja text-uppercase" plain>{{ item.title }}</v-list-item-title>
                </v-list-item>
                  <v-list-group v-else @click.stop :value="true" no-action sub-group prepend-icon="">
                    <template v-slot:activator>
                      <v-btn :to="item.to" plain class="naranja" style="padding:0px;font-size:1rem;margin-left:-16px;"> {{ item.title }}</v-btn>
                    </template>
                    <v-list-item
                      v-for="(subitem, i) in item.sublinks"
                      :key="i" :to="subitem.to"
                    >
                      <v-list-item-title class="naranja" style="margin-left:-48px;" plain>{{ subitem.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-group>
              </div>
            </v-list>
          </v-menu>
      </template>

    </v-app-bar>

    <v-main dark class="grey darken-3">
      <router-view></router-view>
    </v-main>

    <v-footer
        dark
        class="grey darken-4"
      >
        <v-card
          flat
          tile
          class="grey darken-4 text-center flex"
        >
          <v-card-text class="pa-1">
            <v-btn
              v-for="icon in icons"
              :key="icon.icon"
              class="mx-4 white--text"
              iconc
              :href="icon.path"
              target="_blank"
            >
              <v-icon size="36px">
                {{ icon.icon }}
              </v-icon>
            </v-btn>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="white--text text-right">
            
            <v-btn text plain href="mailto:peludaviu@hotmail.com">
              <v-icon left>
                mdi-email
              </v-icon>
              peludaviu@hotmail.com
            </v-btn>
            <v-btn text plain href="tel:961182727"> 
              <v-icon left>
                mdi-phone
              </v-icon>
              961182727
            </v-btn>
            <v-btn text plain small href="https://g.page/Nuriadaviu?share" 
              target="_blank"> 
              <v-icon left>
                mdi-map-marker
              </v-icon>
              C/Ejército Español 11
            </v-btn>
          </v-card-text>
        </v-card>
      </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    icons: [
        {icon:'mdi-facebook', path:'https://facebook.com/estilismenuriadaviu'},
        {icon:'mdi-instagram', path:'https://instagram.com/nuriadaviu'},
    ],
    menu: [
      { to: "/", title: "Home"},
      { to: "/gallery/general", title: "Galería",
        sublinks: [
          {to: "/gallery/general", title: "General"},
          {to: "/gallery/tradicional", title: "Peinados Tradicionales"},
          {to: "/gallery/novias", title: "Novia y Fiesta"},
          {to: "/gallery/pasarelas", title: "Pasarelas"},
          {to: "/gallery/historia", title: "Historia"},
          {to: "/gallery/enzymo", title: "Enzymoterapias"},
          {to: "/gallery/looks", title: "Cambios de look"},
        ]
      },
      { to: "/services", title: "Servicios"},
      { to: "/contact", title: "Contacto"}
    ]
  }),
  computed: {
     heightLogo() { 
       return "margin-top:5px;max-height:" + (this.$vuetify.breakpoint.smAndDown ? 50 : 60) + "px"
     }
  }
};
</script>
<style scoped>
.v-list-group__header {
    padding: 0px;
}

</style>